export const FETCH_INVENTORYLIST_REQUEST = "FETCH_INVENTORYLIST_REQUEST";
export const FETCH_INVENTORYLIST_SUCCESS = "FETCH_INVENTORYLIST_SUCCESS";
export const FETCH_INVENTORYLIST_FAILURE = "FETCH_INVENTORYLIST_FAILURE";
